/* eslint-disable camelcase */
/* eslint-disable react/no-unused-class-component-methods */
/* eslint-disable no-use-before-define */
/* eslint-disable react/void-dom-elements-no-children */

import React, { Component } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import Button from "../../../shared/components/button/button";
import InputFieldComponent from "../../../shared/components/forms/input-field/input-field";

import * as actions from "../../../store/createprod/actions";
import nexumLogo from "../../../assets/nexumLogo.png";

import Sidebar from "../../../shared/components/sidebar";
import {
  CreateProductProps,
  CreateProductState,
  MapStateToPropsCreateProduct,
} from "../../../shared/interfaces/components/createproduct.interface";

class CreateProduct extends Component<CreateProductProps, CreateProductState> {
  constructor(props: CreateProductProps) {
    super(props);

    this.state = {
      name: "",
      desc: "",
      appUrl: "",
    };
  }

  componentDidUpdate(prevProps: CreateProductProps) {
    if (this.props.isCreateProductOk) {
      this.props.location("/private/productlist");
      window.location.reload();
    }
  }

  refName: React.RefObject<HTMLInputElement> = React.createRef();

  refDescription: React.RefObject<HTMLInputElement> = React.createRef();

  refAppUrl: React.RefObject<HTMLInputElement> = React.createRef();

  render() {
    // destructuring state
    const { name, desc, appUrl } = this.state;
    // destructuring props
    const { postCreateProductRequest } = this.props;

    const sendData = (data: object) => {
      postCreateProductRequest(data);
    };

    const nameChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      this.setState({ name: data.target.value });
    };
    const descChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      this.setState({ desc: data.target.value });
    };
    const appUrlChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      this.setState({ appUrl: data.target.value });
    };

    return (
      <div>
        <Sidebar />
        <div className="fixed top-0 bg-blue bg-opacity-10 h-screen w-screen -z-10" />
        <div
          className="w-full md:w-10/12 h-screen my-auto ml-auto"
          data-test="signup-wrapper"
        >
          <section className="p-2 md:p-10 w-full box-border flex flex-row flex-wrap justify-center">
            <div className="login-body">

              <div className="login-wrapper">
                <article className="">
                  <div className="loginbox shadow-md">
                    <div className="login-left">
                      <img
                        className="img-fluid"
                        src={nexumLogo}
                        alt="nexumLogo"
                      />
                    </div>
                    <div className="login-right">
                      <div className="login-right-wrap">
                        <h1>Crea Prodotto</h1>

                        <form>
                          <div className="form-group">
                            <InputFieldComponent
                              data-test="name"
                              name="name"
                              id="create-name"
                              type="text"
                              label="Nome prodotto"
                              value={name}
                              ref={this.refName}
                              title="Inserire campo"
                              required
                              onChangeHandler={nameChange}
                            />
                          </div>
                          <div className="form-group">
                            <InputFieldComponent
                              data-test="desc"
                              name="description"
                              id="create-description"
                              type="text"
                              label="Descrizione"
                              value={desc}
                              ref={this.refDescription}
                              title="Inserire campo"
                              required
                              onChangeHandler={descChange}
                            />
                          </div>
                          <div className="form-group">
                            <InputFieldComponent
                              data-test="appUrl"
                              name="appUrl"
                              id="create-url"
                              type="text"
                              label="Indirizzo Url"
                              value={appUrl}
                              ref={this.refAppUrl}
                              title="Inserire campo"
                              required
                              onChangeHandler={appUrlChange}
                            />
                          </div>
                          <div className="form-group">
                            <Button
                              title="Salva"
                              onClickHandler={() => {
                                sendData(this.state);
                              }}
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  postCreateProductRequest: (payload: object) => {
    dispatch(actions.postCreateProductRequest(payload));
  },
});

export const mapStateToProps = (state: MapStateToPropsCreateProduct) => ({
  isCreateProductOk: state.createProductReducer.isCreateProductOk,
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateProduct);
